export default __webpack_public_path__ + "8433be96c9d8541fc315f034f3f529e9.png";